export const ONE_SIGNAL_ICON_CONTAINER_ID = 'onesignal-bell-container'
export const SHOW_ONE_SIGNAL_TEXT_BUS_NAME = 'show-one-signal-text'
